import React from "react";
import { cn } from "@/lib/utils";
import MapleOSLogo from "@/components/common/MapleOSLogo";

type BrandLogoProps = {
  className?: string;
  size?: number;
  showWordmark?: boolean;
  logoClassName?: string;
};

export default function BrandLogo({ className, size = 28, logoClassName }: BrandLogoProps) {
  return (
    <span className={cn("inline-flex items-center gap-2", className)}>
      <MapleOSLogo
        className={cn("text-foreground", logoClassName)}
        // height controls nicely; width auto based on viewBox
        style={{ height: size, width: "auto" } as React.CSSProperties}
      />
    </span>
  );
}